import { useContext } from "react";
import { getAuthUser } from "../../../api/auth";
import { SubscriptionsContext } from "../store/SubscriptionsContext";
import { PickupContext } from "../store/PickupContext";
import { PickupLocationContext } from "../store/PickupLocationContext";
import { UserPickupContext } from "../store/UserPickupContext";

export type ClientSubscription = {
  pickupLocation: string | undefined;
  pickupDay: string | undefined;
  tierName: string | undefined;
  subscriptionName: string | undefined;
  isSubscriptionActive: boolean;
};

export const useClientSubscription = () => {
  const { subscriptions, tiers } = useContext(SubscriptionsContext);
  const { pickups } = useContext(PickupContext);
  const { pickup: userPickupFromContext } = useContext(UserPickupContext);
  const { pickupLocations } = useContext(PickupLocationContext);
  const authUser = getAuthUser();

  const userPickup =
    pickups.find((pickup) => pickup.userId === authUser?.userId) ??
    userPickupFromContext ??
    undefined;

  const userPickupLocation = pickupLocations.find((loc) => {
    return loc._id === userPickup?.pickupLocationId;
  });

  const userPickupDay = userPickupLocation?.days.find((day) => {
    return day.day === userPickup?.pickupDay;
  });
  
  const userTier = tiers.find((tier) => {
    return tier.id === userPickup?.subscriptionTierId;
  });
  const userSubscription = subscriptions.find((sub) => {
    return sub.id === userTier?.subscriptionId;
  });

  return {
    pickupLocation: userPickupLocation?.name,
    pickupDay: userPickupDay?.day,
    tierName: userTier?.name,
    subscriptionName: userSubscription?.name,
    isSubscriptionActive: userSubscription?.isActive ?? false,
  };
};
